var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "basket",
    transform: "translate(-0.15 0.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2691",
    "data-name": "Group 2691",
    transform: "translate(0.15 -0.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    d: "M.357,10.094a1.208,1.208,0,0,1-1-1.878L5.038-.312a1.208,1.208,0,1,1,2.01,1.34L1.363,9.556A1.207,1.207,0,0,1,.357,10.094Z",
    transform: "translate(5.114 0.85)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_9",
    "data-name": "Line 9",
    d: "M4.623,10.094a1.208,1.208,0,0,1-1.082-.668L-.722.9A1.208,1.208,0,0,1,1.439-.182L5.7,8.346a1.209,1.209,0,0,1-1.08,1.749Z",
    transform: "translate(17.906 0.85)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    d: "M22.621,29.611H6.967A3.821,3.821,0,0,1,3.15,25.794V15.358a1.208,1.208,0,0,1,2.416,0V25.794a1.4,1.4,0,0,0,1.4,1.4H22.621a1.4,1.4,0,0,0,1.4-1.4V15.358a1.208,1.208,0,0,1,2.416,0V25.794a3.817,3.817,0,0,1-3.817,3.817Z",
    transform: "translate(-0.541 -1.611)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_10",
    "data-name": "Line 10",
    d: "M25.942,1.566H.358a1.208,1.208,0,1,1,0-2.416H25.942a1.208,1.208,0,0,1,0,2.416Z",
    transform: "translate(0.85 9.378)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_11",
    "data-name": "Line 11",
    d: "M.358,7.252A1.208,1.208,0,0,1-.85,6.043V.358a1.208,1.208,0,1,1,2.416,0V6.043A1.208,1.208,0,0,1,.358,7.252Z",
    transform: "translate(13.642 16.485)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_12",
    "data-name": "Line 12",
    d: "M.358,7.252A1.208,1.208,0,0,1-.85,6.043V.358a1.208,1.208,0,1,1,2.416,0V6.043A1.208,1.208,0,0,1,.358,7.252Z",
    transform: "translate(9.378 16.485)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_13",
    "data-name": "Line 13",
    d: "M.358,7.252A1.208,1.208,0,0,1-.85,6.043V.358a1.208,1.208,0,1,1,2.416,0V6.043A1.208,1.208,0,0,1,.358,7.252Z",
    transform: "translate(17.906 16.485)",
    fill: "#00246a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProduct);
export default __webpack_public_path__ + "static/media/Product.8b5dfd0ce8461a785eb7d9ee6c561b11.svg";
export { ForwardRef as ReactComponent };